var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 100 55",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,75.000000) scale(0.100000,-0.100000)",
    fill: "#827c78",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 628 c-135 -66 -253 -127 -262 -135 -10 -9 -20 -30 -24 -48 -5 -27 9 -60 81 -204 77 -154 89 -174 120 -187 19 -8 36 -14 37 -14 2 0 2 96 0 212 -3 209 -3 214 20 247 43 64 71 71 265 71 l173 0 -39 78 c-39 77 -67 103 -109 101 -9 0 -127 -55 -262 -121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 500 c-49 -20 -54 -41 -54 -248 l0 -194 29 -29 29 -29 281 0 c154 0 291 4 305 10 48 18 56 53 56 244 0 114 -4 184 -12 201 -23 52 -43 55 -340 54 -150 0 -283 -4 -294 -9z m591 -75 c0 -20 -6 -20 -293 -19 -161 1 -295 4 -298 6 -2 3 -2 13 2 22 6 15 34 16 298 14 283 -3 291 -4 291 -23z m5 -230 c0 -125 0 -126 -25 -135 -14 -5 -140 -9 -290 -7 -224 2 -267 4 -275 17 -5 8 -10 68 -10 133 l0 117 300 0 300 0 0 -125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 191 c-22 -22 -25 -38 -15 -66 9 -23 51 -37 74 -25 13 7 28 7 46 0 37 -15 74 10 74 50 0 39 -26 63 -59 55 -32 -7 -40 -7 -73 1 -19 4 -32 0 -47 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.f11228c1c2b9af0ffcc016971c9ee480.svg";
export { ForwardRef as ReactComponent };